import { _ } from "../../../core/polyglot/polyglot.js";
import { hasProtocol, isValidUrl } from "../../../core/helpers/string-util.js";
import { MenuItem } from "prosemirror-menu";
import { openPrompt, TextField } from "./prosemirror-example-setup.js";
import { toggleMark } from "prosemirror-commands";
import AbstractAction from "./AbstractAction.js";
import OrderedMenuItem from "../OrderedMenuItem.js";

/**
 * Action providing `link`.
 */
export default class LinkAction extends AbstractAction {
	getMarks() {
		return {
			link: {
				attrs: {
					href: {},
					title: { default: null },
					target: { default: "_blank" },
				},
				inclusive: false,
				parseDOM: [
					{
						tag: "a[href]",
						getAttrs(dom) {
							return {
								href: dom.getAttribute("href"),
								title: dom.getAttribute("title"),
								target: dom.getAttribute("target"),
							};
						},
					},
				],
				toDOM(node) {
					const { href, title, target } = node.attrs;
					return ["a", { href, title, target }, 0];
				},
			},
		};
	}

	getMenuItems({ schema }) {
		return [this._makeLinkItem(schema.marks.link)];
	}

	_makeLinkItem(mark) {
		return new OrderedMenuItem({
			order: 30,
			menuItem: new MenuItem({
				title: _("Toggle link"),
				icon: this._makeIcon({ cssClass: "fa fa-link" }),
				active: (state) => this._isMarkActive({ state, type: mark }),
				enable: (state) => !state.selection.empty,
				run: this._makeLinkCommand(mark),
			}),
		});
	}

	_makeLinkCommand(mark) {
		return (state, dispatch, view) => {
			this._isMarkActive({ state, type: mark })
				? toggleMark(mark)(state, dispatch)
				: this._openLinkPrompt({ mark, view });
		};
	}

	_openLinkPrompt({ mark, view }) {
		openPrompt({
			fields: {
				href: new TextField({
					label: _("Paste or type a link").toString(),
					required: true,
					validate: this._validateUrl.bind(this),
				}),
			},
			callback: (attrs) => {
				if (!hasProtocol(attrs.href)) {
					attrs.href = `https://${attrs.href}`;
				}
				toggleMark(mark, attrs)(view.state, view.dispatch);
				view.focus();
			},
		});
	}

	_validateUrl(url) {
		if (!isValidUrl(url)) {
			return _("Invalid URL");
		}

		return undefined;
	}
}
